var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomePence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=IncomePence, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M14 6C18.9706 6 23 10.0294 23 15C23 19.9706 18.9706 24 14 24C9.02944 24 5 19.9706 5 15C5 10.0294 9.02944 6 14 6ZM14 8C10.134 8 7 11.134 7 15C7 18.866 10.134 22 14 22C17.866 22 21 18.866 21 15C21 11.134 17.866 8 14 8Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xC2\xA5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.7088 14.2119H17.296V15.5212H15.0048V16.3475H17.296V17.6568H15.0048V19.5H12.9824V17.6568H10.704V16.3475H12.9824V15.5212H10.704V14.2119H12.3296L10 10.5H12.368L14.0576 13.8051L15.7088 10.5H18L15.7088 14.2119Z",
    fill: "#E0E4E7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M35 26C39.9706 26 44 30.0294 44 35C44 39.9706 39.9706 44 35 44C30.0294 44 26 39.9706 26 35C26 30.0294 30.0294 26 35 26ZM35 28C31.134 28 28 31.134 28 35C28 38.866 31.134 42 35 42C38.866 42 42 38.866 42 35C42 31.134 38.866 28 35 28Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xC2\xA5_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M36.7088 34.2119H38.296V35.5212H36.0048V36.3475H38.296V37.6568H36.0048V39.5H33.9824V37.6568H31.704V36.3475H33.9824V35.5212H31.704V34.2119H33.3296L31 30.5H33.368L35.0576 33.8051L36.7088 30.5H39L36.7088 34.2119Z",
    fill: "#E0E4E7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76611 35.5C8.76611 35.6812 8.81537 35.8591 8.90862 36.0145L13.1424 43.0708C13.4266 43.5444 14.0408 43.698 14.5144 43.4138C14.6552 43.3294 14.773 43.2116 14.8574 43.0708L19.0912 36.0145C19.3754 35.5409 19.2218 34.9267 18.7482 34.6425C18.5928 34.5493 18.415 34.5 18.2337 34.5L15.9991 34.499L15.9999 27.5C15.9999 26.9477 15.5522 26.5 14.9999 26.5H12.9999C12.4476 26.5 11.9999 26.9477 11.9999 27.5L11.9991 34.499L9.76611 34.5C9.21383 34.5 8.76611 34.9477 8.76611 35.5ZM40.2339 14.5565C40.2339 14.3753 40.1846 14.1974 40.0914 14.042L35.8576 6.98566C35.5734 6.51208 34.9592 6.35851 34.4856 6.64266C34.3448 6.72711 34.227 6.84491 34.1426 6.98566L29.9088 14.042C29.6246 14.5156 29.7782 15.1298 30.2518 15.414C30.4072 15.5072 30.585 15.5565 30.7663 15.5565L33.0009 15.5575L33.0001 22.5565C33.0001 23.1088 33.4478 23.5565 34.0001 23.5565H36.0001C36.5524 23.5565 37.0001 23.1088 37.0001 22.5565L37.0009 15.5575L39.2339 15.5565C39.7862 15.5565 40.2339 15.1088 40.2339 14.5565Z",
    fill: "#C3CBD3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomePence);
export default __webpack_public_path__ + "static/media/incomePence.1bfba31b2b306266e72216084135cf3b.svg";
export { ForwardRef as ReactComponent };